import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationES from "../locales/es.json";
import translationEN from "../locales/en.json";
import translationPT from "../locales/pt.json";

const resources = {
  en: { translation: translationEN },
  es: { translation: translationES },
  pt: { translation: translationPT },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "es",
    supportedLngs: ["es", "en", "pt"],
    load: "languageOnly",
    detection: {
      order: ["localStorage", "navigator", "htmlTag", "path", "subdomain"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
      excludeCacheFor: ["cimode"],

      // LA FUNCIONALIDAD NATIVA DEL DETECTOR
      convertDetectedLanguage: (lng) => typeof lng === "string" ? lng.split("-")[0] : lng,
    },
    interpolation: { escapeValue: false },
  });

export default i18n;